import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Label } from "@/components/common";
import { Overview } from "@/components/pilotage/Overview";
import { Suppliers } from "@/components/pilotage/Suppliers";
import { Prices } from "@/components/pilotage/Prices";
import { Alerts } from "@/components/pilotage/Alerts";
import { Stock } from "@/components/pilotage/Stock";

const TABS = [["overview", "Vue d'ensemble"], ["suppliers", "Fournisseurs"], ["prices", "Suivi des prix"], ["alerts", "Alertes"], ["stock", "Stock Quantelys"]];

export default function Pilotage() {
  const [tab, setTab] = useState("overview");
  return (
    <div className="space-y-6" data-testid="pilotage-page">
      <div><Label>Finances</Label><h1 className="font-display text-3xl font-semibold tracking-tight sm:text-4xl">Pilotage financier</h1>
        <p className="mt-1 text-sm text-gray-500">Achats et charges issus de vos factures fournisseurs, évolution des prix et alertes. Montants HT, factures en double exclues.</p></div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex h-auto flex-wrap rounded-full">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`pil-tab-${v}`} className="rounded-full">{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="overview" className="mt-4"><Overview onNav={setTab} /></TabsContent>
        <TabsContent value="suppliers" className="mt-4"><Suppliers /></TabsContent>
        <TabsContent value="prices" className="mt-4"><Prices /></TabsContent>
        <TabsContent value="alerts" className="mt-4"><Alerts /></TabsContent>
        <TabsContent value="stock" className="mt-4"><Stock /></TabsContent>
      </Tabs>
    </div>
  );
}
